<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="date-wrapper">
				<FilterChipButton
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
				/>
			</div>
			<div class="events-page__wrap">
				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>
			</div>

			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading || isCategoryIdNotSet"
					v-bind="attrs"
					max-width="555"
					width="100%"
					type="card"
				></v-skeleton-loader>

				<div v-else style="width: 100%">
					<div
						v-for="(dir, index) in directoriesNormalize"
						:key="index"
						@click="toggleDirectory(dir.directory_id)"
					>
						<router-link
							:to="{
								name: 'directory-by-id',
								params: {
									id: dir.directory_id,
								},
								query: {
									category_id: categoryId,
								},
							}"
							class="text-decoration-none"
						>
							<DirectoryPreview :directory="dir" />
						</router-link>
					</div>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && directories.length > 0 && !isCategoryIdNotSet"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageDirectories"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && directories.length <= 0 && !isCategoryIdNotSet"
			>
				<NewsFeedEmpty
					title="Directories not found at this moment."
					description="Check back later."
					centering="center"
				/>
			</div>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import DirectoryPreview from '@/components/Directory/DirectoryPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter.js'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'DirectoriesPage',
	mixins: [Block, Filter, Dwh],
	components: {
		FilterChipButton,
		NewsFeedEmpty,
		DirectoryPreview,
		Pagination,
		PageBlocked,
		FilterModal,
	},
	methods: {
		...mapActions('directory', ['getDirectories', 'clearDirectories']),
		...mapActions('app', ['setPageTitle']),
		toggleDirectory(userId) {
			this.sendTrigger({
				category: 'Content',
				action: 'directory_item_click',
				module: 'Directories',
				data: this.$route.query.category_id,
				content_chapter_id: userId,
			})
		},

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.getDirectories(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('settings', ['appCore']),
		...mapGetters('directory', ['directories', 'pageDirectories', 'isLoading']),

		redirectBaseUrl() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.baseMenuItems.find(
				(item) => item.route.name === 'directory'
			)
		},
		isCategoryIdNotSet() {
			return Boolean(!this.$route.query.category_id)
		},
		categoryId() {
			if (this.$route.query.category_id) {
				return this.$route.query.category_id
			}

			return false
		},

		directoriesNormalize() {
			return this.directories || []
		},
	},
	watch: {
		appCore: {
			handler(appCore) {
				if (!this.$route.query.category_id && appCore) {
					const { route } = this.redirectBaseUrl || {}

					this.$router.push({
						name: route.name,
						query: route.query,
					})
				}
			},
			immediate: true,
		},
		'$route.query.category_id': function (newValue) {
			if (newValue) {
				this.clearDirectories()
				this.getDirectories(this.requestQuery)
				this.setPageTitle(this.$route.query.title)
			}
		},
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		this.setPageTitle(this.$route.query.title)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			pageBlockedName: 'directory',
		}
	},
}
</script>

<style lang="scss">
.directory-page {
	background: #f1f1f1 !important;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: 'Inter', sans-serif;
		font-weight: bold;
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}
}
</style>
